export default "__VITE_ASSET__DUdRu$PL__"